export default __webpack_public_path__ + "static/media/long-logo.72e4ff65.svg";